const cashinSplitMode = {
  PERCENTAGE: 'PERCENTUAL',
  FIXED: 'FIXADO'
};

module.exports = cashinSplitMode;
